
import { format, parseISO } from "date-fns";
import { es } from "date-fns/locale";
import { PaymentStatusBadge } from "./PaymentStatusBadge";

interface PaymentInfoProps {
  payment: {
    houses?: { name: string } | null;
    amount: string;
    payment_date: string;
    status: string;
    description?: string | null;
  };
}

export const PaymentInfo = ({ payment }: PaymentInfoProps) => {
  // Parse amount string to number for formatting
  const amountNumber = parseFloat(payment.amount);

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <p className="text-sm text-gray-500">Propiedad</p>
          <p className="font-medium">{payment.houses?.name}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Monto</p>
          <p className="font-medium">
            ${amountNumber.toLocaleString('es-CL')}
          </p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Fecha de pago</p>
          <p className="font-medium">
            {format(parseISO(payment.payment_date), "d 'de' MMMM 'de' yyyy", { locale: es })}
          </p>
        </div>
        <div>
          <PaymentStatusBadge status={payment.status} />
        </div>
      </div>
      
      {payment.description && (
        <div>
          <p className="text-sm text-gray-500">Descripción</p>
          <p className="font-medium">{payment.description}</p>
        </div>
      )}
    </div>
  );
};
